import {AuthService} from "./AuthService";

export class QueueService {
    url = `queues/`;

    createQueueItem(process_type, param) {
        return AuthService.apiPost(this.url, {"process_type": process_type, "param": param}).then(res => res.data);
    }

    consumeQueue() {
        return AuthService.apiPut(this.url + 'consume_queue/', {}).then(res => res.data);
    }

    list(filters) {
        return AuthService.apiGet(this.url, {params: filters}).then(res => res.data.data);
    }

    summary(filters) {
        return AuthService.apiGet(this.url + 'summary/', {params: filters}).then(res => res.data.data);
    }

    requeue(id) {
        return AuthService.apiPost(this.url + id + '/requeue/', {}).then(res => res.data.data);
    }

    remove(id) {
        return AuthService.apiDelete(this.url + id + '/').then(res => res.data);
    }

    bulk(op, ids) {
        return AuthService.apiPost(this.url + 'bulk/', {op, ids}).then(res => res.data.data);
    }
}
